import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1f3a27] text-[#f6f1e6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>Earthly Spice Exports</h3>
            <p className="text-[#d8d9cd] mb-4">
              Premium quality spices directly sourced and processed in Bangalore, India.
            </p>
            <div className="space-y-2 text-[#d8d9cd]">
              <h2>Address</h2>
              <p> No.21 Shop No. 2, 2nd Main, 4th Cross Royal Colony
              Near Chowdeshwari Bar, Medarahalli, Chikkabanavara Post, Bengaluru - 560090, Karnataka</p>
              
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#d8d9cd] hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#d8d9cd] hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-[#d8d9cd] hover:text-white transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/quality" className="text-[#d8d9cd] hover:text-white transition-colors">
                  Quality & Packaging
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#d8d9cd] hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>Contact Us</h3>
            <div className="space-y-3 text-[#d8d9cd]">
              <p>
                <span className="font-semibold">Phone:</span>{' '}
                <a href="tel:+919902043782" className="hover:text-white transition-colors">
                  +91 99020 43782
                </a>
              </p>
              <p>
                <span className="font-semibold">Email:</span>{' '}
                <a href="mailto:admin@earthlyspiceexports.com" className="hover:text-white transition-colors">
                  admin@earthlyspiceexports.com
                </a>
              </p>
              <p>
                <a
                  href="https://wa.me/919902043782"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-[#2d5a3c] hover:bg-[#21432d] px-4 py-2 rounded-full transition-colors"
                >
                  <span>WhatsApp Us</span>
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#35533a] mt-8 pt-8 text-center text-[#d8d9cd]">
          <p>&copy; {new Date().getFullYear()} Earthly Spice Exports. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
